/* ============================================================================
   subscription.js - tier IDs, credit amounts, and access helpers
   ============================================================================ */

import {
  SUBSCRIPTION_TIERS,
  TIER_CREDITS,
  isFirstCreditBonusActive,
} from "./sample-data.js?v=20261007m";

/** Map retired Ko-fi / Firestore tier IDs to the current tier model. */
export function mapLegacyTierId(id) {
  const legacy = {
    snack: "batch",
    cookie: "batch",
    author: "batch",
    studio: "master",
  };
  return legacy[id] || id || "free";
}

export function getMonthlyCredits(tierId) {
  return TIER_CREDITS[mapLegacyTierId(tierId)] ?? 0;
}

export function isMasterTier(tierId) {
  return mapLegacyTierId(tierId) === "master";
}

export function isPaidTier(tierId) {
  const id = mapLegacyTierId(tierId);
  return id === "dough" || id === "batch" || id === "master";
}

export function getTierById(tierId) {
  const id = mapLegacyTierId(tierId);
  return SUBSCRIPTION_TIERS.find((t) => t.id === id) ?? SUBSCRIPTION_TIERS[0];
}

/** Short ribbon label for paid tiers on profile avatar. */
export function tierBadgeLabel(tierId) {
  const id = mapLegacyTierId(tierId);
  if (id === "dough") return "Cookie Dough";
  if (id === "batch") return "Cookie Batch";
  if (id === "master") return "Sugar Rush";
  return null;
}

/** Retired: no Sugar Rush-only vault products. Kept for call-site compatibility. */
export function isMasterExclusive(_product) {
  return false;
}

/** Members Pantry catalog  -  free to download, but paid tier only. */
export function isMembersPantryProduct(product) {
  return Boolean(product?.members_pantry);
}

/** Free vault items (0 credits)  -  available to any signed-in member without unlock. */
export function isFreeVaultProduct(product) {
  if (!product || isMasterExclusive(product) || isMembersPantryProduct(product)) return false;
  return Number(product.price_in_credits || 0) <= 0;
}

export function hasMembersPantryAccess(tierId) {
  return isPaidTier(mapLegacyTierId(tierId));
}

/** Choice Board: all signed-in members. Free tier is capped in the editor (1/1/15). */
export function hasStoryMapAccess(_tierId) {
  return true;
}

/** Apply one-time 2× bonus on the first paid credit deposit (while launch promo is active). */
export function creditsWithFirstBonus(baseCredits, userData = {}) {
  const base = Number(baseCredits) || 0;
  if (base <= 0) return { amount: 0, bonusApplied: false };
  if (!isFirstCreditBonusActive()) return { amount: base, bonusApplied: false };
  if (userData.first_credit_bonus_pending === false) {
    return { amount: base, bonusApplied: false };
  }
  return { amount: base * 2, bonusApplied: true };
}
